import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name:'custompagination',
})

export class PaginationPipe implements PipeTransform {

    transform(list:any[],page:number,itemperpage:number):any[] {
        return [...list.slice((page-1)*itemperpage,page*itemperpage)]
    }
}